import React, { useState, useEffect } from 'react';
import StrangerThingsAuto from '../components/animations/StrangerThingsAuto';
import Lightning from '../components/background/Lightning';
import { Helmet } from 'react-helmet-async';
import './StrangerThingsLanding.css';

// Import character images
import characterEleven from '../assets/characters/eleven.png';
import characterMike from '../assets/characters/mike.png';
import characterDustin from '../assets/characters/dustin.png';
import characterLucas from '../assets/characters/lucas.png';
import characterWill from '../assets/characters/will.png';
import characterMax from '../assets/characters/max.png';
import characterSteve from '../assets/characters/steve.png';
import characterNancy from '../assets/characters/nancy.png';
import characterHopper from '../assets/characters/hopper.png';
import characterJoyce from '../assets/characters/joyce.png';
import characterRobin from '../assets/characters/robin.png';
import characterJonathan from '../assets/characters/jonathan.png';

const StrangerThingsLanding = () => {
  const [showLightning, setShowLightning] = useState(false);

  // Global lightning effect - optimized interval
  useEffect(() => {
    const triggerLightning = () => {
      setShowLightning(true);
      setTimeout(() => {
        setShowLightning(false);
      }, 200);
    };

    // Less frequent lightning strikes for better performance
    const interval = setInterval(() => {
      if (Math.random() > 0.8) {
        triggerLightning();
      }
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const characters = [
    { name: 'Eleven', image: characterEleven, role: 'The Gifted' },
    { name: 'Mike Wheeler', image: characterMike, role: 'The Leader' },
    { name: 'Dustin Henderson', image: characterDustin, role: 'The Genius' },
    { name: 'Lucas Sinclair', image: characterLucas, role: 'The Warrior' },
    { name: 'Will Byers', image: characterWill, role: 'The Sensitive' },
    { name: 'Max Mayfield', image: characterMax, role: 'The Fearless' },
    { name: 'Steve Harrington', image: characterSteve, role: 'The Protector' },
    { name: 'Nancy Wheeler', image: characterNancy, role: 'The Investigator' },
    { name: 'Chief Hopper', image: characterHopper, role: 'The Guardian' },
    { name: 'Joyce Byers', image: characterJoyce, role: 'The Mother' },
    { name: 'Robin Buckley', image: characterRobin, role: 'The Decoder' },
    { name: 'Jonathan Byers', image: characterJonathan, role: 'The Observer' }
  ];

  return (
    <>
      <Helmet>
        <title>Stranger Things - Journey to the Upside Down</title>
        <meta name="description" content="Experience the supernatural world of Stranger Things. Join the warriors in their fight against the darkness." />
      </Helmet>

      <div className="stranger-things-landing">
        {/* Global Lightning Overlay */}
        {showLightning && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
            zIndex: 9999,
            mixBlendMode: 'screen'
          }}>
            <Lightning
              hue={0}
              xOffset={Math.random() * 100}
              speed={2}
              intensity={8.0}
              size={0.3}
            />
          </div>
        )}

        {/* Hero Section - Just StrangerThingsAuto component as is */}
        <section className="hero-section">
          <StrangerThingsAuto
            numEffects={3}
            trailLength={30}
            bloomStrength={0.3}
            bloomRadius={0.5}
            brightness={1.0}
            enableLightningStrikes={true}
            lightningInterval={4000}
            lightningDuration={200}
            lightningIntensity={3.0}
          />
        </section>

        {/* Warriors Section */}
        <section className="warriors-section">
          <div className="warriors-container">
            <div className="section-title-wrapper">
              <h2 className="section-title red-glow">The Warriors</h2>
              <div className="title-underline"></div>
            </div>

            <div className="characters-grid">
              {characters.map((character, index) => (
                <div
                  key={index}
                  className="character-card"
                  style={{
                    animationDelay: `${index * 0.08}s`
                  }}
                >
                  <div className="character-image-wrapper">
                    <img
                      src={character.image}
                      alt={character.name}
                      className="character-image"
                      loading="lazy"
                    />
                    <div className="character-overlay">
                      <div className="character-lightning"></div>
                    </div>
                  </div>
                  <div className="character-info">
                    <h3 className="character-name">{character.name}</h3>
                    <p className="character-role">{character.role}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Footer Section */}
        <section className="landing-footer">
          <div className="footer-content">
            <p className="footer-tagline">
              "Friends don't lie. And neither do the monsters."
            </p>
          </div>
        </section>
      </div>
    </>
  );
};

export default StrangerThingsLanding;
